import React from "react";
import { useNavigate } from "react-router-dom";

// CSS Import
import "./index.css";

const FullScreen = ({ id, setAlertPopUp, type, categoryPass }) => {
  // useNavigate
  const navigate = useNavigate();

  const detailPage = (id) => {
    if (type === "txn") {
      navigate(
        `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${id}`,
      );
    } else if (type === "internalTxn") {
      navigate(
        `/internal_transaction_dashboard/internal_transaction_view_all/internal_transaction_detail_page/${id}`,
      );
    } else if (type === "internalAcc") {
      navigate(
        `/internal_account_dashboard/internal_account_view_all/internal_account_detail_page/${id}`,
      );
    } else if (type === "scheduleTxn") {
      navigate(
        `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${id}`,
      );
    } else if (type === "Schedule_Internal_Txn") {
      navigate(
        `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${id}`,
      );
    } else if (type === "BulkUploadView") {
      if (categoryPass) {
        navigate(
          "/beneficiary_transaction_dashboard/bulk_transaction_view_all",
          {
            state: {
              categoryFilter: categoryPass,
            },
          },
        );
      } else {
        navigate(
          "/beneficiary_transaction_dashboard/bulk_transaction_view_all",
        );
      }
    } else {
      navigate("/beneficiary_account_dashboard/beneficiary_account_view_all");
      // navigate(`/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/${id}`);
    }
  };
  return (
    <div className="w-[35rem] h-auto rounded-[1.25rem] bg-Blue-3 p-[1.25rem] flex flex-col gap-[1rem] mx-[0.625rem] animate-none Qmd:animate-slideInFromRight">
      <div className="mb-[3.125rem]">
        <h2 className="text-Header-orange font-semibold text-xl">
          Open in full view?
        </h2>
        <p className="text-text-primary mt-margin-xs text-font-sm">
          Leaving this page will exit you from current flow.
        </p>
      </div>
      <div className="flex justify-end">
        <button
          className="text-text-primary underline text-font-xs hover:text-text-secondary"
          onClick={() => setAlertPopUp(false)}
        >
          Cancel
        </button>
        <button
          className="text-primary-bg justify-center items-center py-padding-button-m px-padding-button-l bg-text-primary ml-margin-md h-auto rounded-border-radius-md global-hover-white relative text-font-xs"
          onClick={() => detailPage(id)}
        >
          Leave
        </button>
      </div>
    </div>
  );
};

export default FullScreen;
